import { Box, Typography } from '@mui/material';
import { N11OrderProduct } from '../../../interfaces/N11/N11OrderProduct';
import { sharedColors, sharedStyles } from '../../../utils/Style';
import { N11Order } from '../../../interfaces/N11/N11Order';

interface ProductRowProps {
  product: N11OrderProduct;
}

const ProductRow = (props: ProductRowProps) => {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
      <Typography sx={{ ...sharedStyles.body2, fontWeight: 'bold' }}>
        {props.product.productName}
      </Typography>

      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          gap: 0.2,
          flexWrap: 'wrap',
        }}
      >
        <Typography sx={sharedStyles.body2}>SKU:</Typography>
        <Typography sx={{ ...sharedStyles.body2, color: sharedColors.gray5 }}>
          {props.product.sku}
        </Typography>
      </Box>

      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          gap: 0.2,
          flexWrap: 'wrap',
        }}
      >
        <Typography sx={sharedStyles.body2}>Miktar:</Typography>
        <Typography sx={{ ...sharedStyles.body2, color: sharedColors.gray5 }}>
          {props.product.quantity.toString()}
        </Typography>
      </Box>
    </Box>
  );
};

interface N11ProductsCellProps {
  order: N11Order;
}

export const N11ProductsCell = (props: N11ProductsCellProps) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: 1.5,
        maxHeight: 250,
        overflowY: 'auto',
      }}
    >
      {props.order.products.map((product, i) => (
        <ProductRow key={i} product={product} />
      ))}
    </Box>
  );
};
